export const mapDtoToImage = dto => ({
  source: dto.full,
  id: dto.id,
  thumb: dto.thumb
})
